import React, { useEffect } from "react";
import Sidebar from "src/components/common/Sidebar";
import { RODEO_PAGE_NAME, APPLICATION_NAME } from "src/_config";
import RodeoQnAPage from "src/components/events/rodeoQnA/rodeoQnAPage";

export default function RodeoQnAContainer() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${APPLICATION_NAME} : Questions`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <React.Fragment>
      <section className="main-container">
        <Sidebar page={RODEO_PAGE_NAME.QUESTION_ANSWER_LIST} />
        <RodeoQnAPage />
      </section>
    </React.Fragment>
  );
}
